import React from "react";
import { InView } from "react-intersection-observer";
import { getAltForCharacter } from "../../utils";

class Waypoint extends React.Component {
  render() {
    const { swapped, character, text } = this.props;
    return (
      <div className="hp-waypoint row align-items-center mb-5">
        <InView threshold={0.25} triggerOnce>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`hp-waypoint__img-col col-12 col-md-4 text-center mb-3 mb-md-0 hp-animate ${swapped ? "order-1 order-md-2 hp-animate--right" : "hp-animate--left"} ${inView ? "is-visible" : ""}`}
            >
              <img
                className="hp-waypoint__img"
                src={`${process.env.REACT_APP_AWS_IMG_CDN}/characters/${character}_no_name.webp`}
                alt={getAltForCharacter(character)}
                width="350"
                height="495"
              />
            </div>
          )}
        </InView>
        <InView threshold={0.25} triggerOnce>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`hp-waypoint__text-col col-12 col-md-7 offset-md-1 hp-animate ${swapped ? "order-2 order-md-1 hp-animate--left" : "hp-animate--right"} ${inView ? "is-visible" : ""}`}
            >
              <div className="hp-waypoint__line" />
              <p className="hp-waypoint__text">{text()}</p>
              <div className="hp-waypoint__line" />
            </div>
          )}
        </InView>
      </div>
    );
  }
}

export default Waypoint;

